// State-qualified matching keeps identically named/acronym bodies separate.
// A complete NFHS member list is one directory scope, not the whole SR market.
export function checkIndependentDirectory(evidence, states) {
  if (!evidence || !Array.isArray(evidence.records) || !Array.isArray(states)) return null
  const codes = new Set()
  const rows = evidence.records.map(row => {
    if (!row.state || codes.has(row.state)) throw new Error('The independent directory repeats or omits a state identity.')
    codes.add(row.state)
    const matches = states.filter(state => state.st === row.state && state.name === row.registryName)
    return { ...row, matched: matches.length === 1 && row.nameMatches === true }
  })
  if (rows.length !== evidence.expectedBodies) throw new Error('The independent directory count does not reconcile.')
  return { expected: rows.length, matched: rows.filter(row => row.matched).length,
    missing: rows.filter(row => !row.matched), rows }
}
